import React from "react";
import { Form, Dropdown } from 'formsy-semantic-ui-react';
import _ from 'lodash';
import { Grid } from "semantic-ui-react";
import setCategoryImage from '../../../helpers/setCategoryImage'


let emptySelect = [{ text: "Select", value: null }]
let noValue = [{ text: "No Data Available", value: null, content: (<span className="clr-red" >No Data Available</span>) }]


class DefaultCategory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            noData: false,
            allCategories: this.selectedData(props.allCategories),
        }
    }

    componentWillMount() {
        this.setDefault(this.props.allCategories)
    }

    componentWillReceiveProps(newProps) {
        if (this.props.allCategories !== newProps.allCategories) {
            this.setDefault(newProps.allCategories)
        }
    }

    selectedData(data) {
        data && data.map(p => {
            delete p.children
            p.key = p._id
            p.text = p.text
            p.nodes = p.nodes
            p.default = p.default
            p.value = p._id;
            p.image = p.isKb ? setCategoryImage(p.image, this.props.selectedAccount) : null
        })
        return data
    }

    setDefault(catData) {

        if (catData && catData.length !== 0) {

            this.setState({
                allCategories: this.selectedData(catData),
            })

            let f1 = catData.filter(f => { return f.default })[0];
            if (f1) {
                this.setState({
                    kb: f1._id,
                    allCat: this.selectedData(f1.nodes),
                })

                let f2 = f1.nodes && f1.nodes.filter(f => { return f.default })[0]
                if (f2) {
                    this.setState({
                        cat: f2._id,
                        allSubCat: this.selectedData(f2.nodes),
                    })

                    let f3 = f2.nodes.filter(f => { return f.default })[0]
                    if (f3) {
                        this.setState({
                            subCat: f3._id,
                        })

                        let selection = [
                            f1._id,
                            f2._id,
                            f3._id
                        ]
                        if (this.props.pageLevel === "import") {
                            this.props.handleCategorySelection(selection)
                        }
                    }
                }
            }
        }
    }

    handleChangeKB = (e, data) => {
        let selKb = data.options.filter((kb, i) => { return kb.value === data.value });
        this.setState({
            kb: data.value,
            cat: null,
            subCat: null,
            allCat: this.selectedData(selKb[0].nodes),
            noData: false
        })
        let selection = [data.value]
        this.props.handleCategorySelection(selection)
    }

    handleChangeCategory = (e, data) => {
        let selCat = data.options.filter((cat, i) => { return cat.value === data.value });

        this.setState({
            cat: data.value,
            subCat: null,
            allSubCat: this.selectedData(selCat[0].nodes)
        })
        let selection = [this.state.kb, data.value]
        this.props.handleCategorySelection(selection)
    }

    handleChangeSubCategory = (e, data) => {
        if (data.value) {
            this.setState({
                subCat: data.value,
            });

            let selection = [this.state.kb, this.state.cat, data.value]
            this.props.handleCategorySelection(selection)
        } else {
            this.setState({
                noData: true,
            });
        }
    }

    render() {
        const { allCategories } = this.state;

        const errorLabel = <div className="customErrorLabel" />;
        const KnowledgeBankDropdown = <React.Fragment>
            <Dropdown
                className="noPointing"
                name="Knowledge"
                pointing={this.props.dropdownPointing ? this.props.dropdownPointing : "top"}
                value={this.state.kb}
                placeholder="Select"
                fluid
                selection
                required
                validationErrors={{
                    isDefaultRequiredValue: 'You need to select a Knowledge Bank',
                }}
                errorLabel={errorLabel}
                options={allCategories}
                onChange={(e, value) => { this.handleChangeKB(e, value) }}
            />
        </React.Fragment>

        let CategoryDropdown = <React.Fragment>
            <Dropdown
                className="noPointing"
                name="Category"
                pointing={this.props.dropdownPointing ? this.props.dropdownPointing : "top"}
                value={this.state.cat}
                //disabled={!this.state.kb || this.state.allCat && this.state.allCat.length === 0}
                placeholder="Select"
                fluid
                selection
                required
                validationErrors={{
                    isDefaultRequiredValue: 'You need to select a Category',
                }}
                errorLabel={errorLabel}
                options={this.state.allCat}
                onChange={(e, value) => { this.handleChangeCategory(e, value) }}
            />
        </React.Fragment>

        let SubCategoryDropdown = <React.Fragment>

            <Dropdown
                className="noPointing"
                name="Sub Category"
                pointing={this.props.dropdownPointing ? this.props.dropdownPointing : "top"}
                placeholder="Select"
                disabled={!this.state.cat || this.state.allSubCat && this.state.allSubCat.length === 0}
                value={this.state.subCat}
                fluid
                selection
                required
                validationErrors={{
                    isDefaultRequiredValue: this.state.noData ? "No Data Available" : 'You need to select a Sub Category',
                }}
                errorLabel={errorLabel}
                options={this.state.allSubCat && this.state.allSubCat.length !== 0 ? this.state.allSubCat : noValue}
                onChange={(e, value) => { this.handleChangeSubCategory(e, value) }}
            />
        </React.Fragment>



        return <div>
            <Form
                className="formcyForm"
            >
                <Grid columns="equal" >
                    <Grid.Row>
                        <Grid.Column className="pad_0">
                            <h4> Knowledge Bank </h4>
                            {KnowledgeBankDropdown}
                        </Grid.Column>
                        <Grid.Column>
                            <h4> Category </h4>
                            {CategoryDropdown}
                        </Grid.Column>
                        <Grid.Column className="pad_0">
                            <h4> Sub Category </h4>
                            {SubCategoryDropdown}
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Form>
        </div>
    }
}
export default DefaultCategory;

